import React, { useEffect, useMemo } from 'react';
import LogoIcon from '../../../../../img/svg/logo-icon.svg'
import Logo from '../../../../../img/svg/logo-white.svg'
import LogoGold from '../../../../../img/logo-gold.svg'

import {
  Container,
  Header,
  TextHeader,
  Img,
  NameRow,
  ImgLogo,
  Description,
  TitleModule,
  FooterReport,
} from './styles'

import { useDispatch, useSelector } from 'react-redux'
import { actions as studentActions } from '../../../../../redux/modules/student';
import { Col } from 'antd';
import BarchartH from '../../../Report/Charts/BarChartH/BarChartH';
import BartChartV from '../../../Report/Charts/BartChartV/BartChartV';
import { Content } from '../../../styles';
import LegendChart from '../../../Report/Charts/SubtitleChart';
import ReportBreakPage from '../../../Report/ReportBreakPage';

// ReportText
import ReportText from '../../../Report/TextDescription';

import {
  getDefaultParams,
  getSusgestionByScoreToro,
  TYPE_COURSE_CATEGORY_CFP,
  TYPE_SCORE_INFORMATION_REPORT_WEEKLY,
  TYPE_SCORE_INFORMATION_REPORT_PDF
} from '../../../common';

import { isEmpty, isNaN } from 'lodash';
import Score from '../../PNG/Score';
import { fetchGeneralText } from '../../../../../redux/api/class';
import {
  RECOMMENDED_CFP,
  CFP_MODULES,
  MODULE_COUNT,
  getRomanModule
} from '../../../constants/examRecommendations';

const TOTAL_REPORTS = 31;

function CfpReport() {
  const [textData, setTextData] = React.useState("");
  const { reportSimulado: report, scoreToroInformation } = useSelector((state) => state.student);
  const suggestion = getSusgestionByScoreToro(scoreToroInformation, Number(((report?.score?.score ?? 0) * 100).toFixed(1)))

  const dispatch = useDispatch();
  useEffect(() => {
    const { userId, courseId, classId, media, start, end, kind, classes } = getDefaultParams(window.location.search);

    dispatch(studentActions.getScoreToroSugestionsByTypes(
      TYPE_COURSE_CATEGORY_CFP,
      TYPE_SCORE_INFORMATION_REPORT_PDF,
      TYPE_SCORE_INFORMATION_REPORT_WEEKLY
    ));

    dispatch(studentActions.handleCfpSimulado(
      userId,
      courseId,
      classId,
      media,
      start,
      end,
      kind,
      classes
    ));
    // eslint-disable-next-line
  }, []);

  useEffect(()=>{
    (async ()=>{
      const filters = {
        typeReportId: TYPE_SCORE_INFORMATION_REPORT_PDF,
        courseCategoryId: TYPE_COURSE_CATEGORY_CFP,
        categoryReportId: TYPE_SCORE_INFORMATION_REPORT_WEEKLY
      }
      const textDataApi = await fetchGeneralText(filters)
      if(textDataApi[0]?.content !== undefined){
        setTextData(textDataApi[0]?.content)
      }
    })()
  },[])



  const reportPerClass = report?.performance_per_class;
  const totalAverage = (report?.average?.acertos_avg * 100).toFixed(1);
  // const totalScore = (report?.score?.score * 100).toFixed(1);
  const modulePerfomance = report?.module_performance;

  const improve = Array.isArray(report?.you_can_improve_module)
    ? [...report.you_can_improve_module]
    : [];
  const reportDone = report?.test?.done ?? [];
  const reportExists = !isEmpty(reportDone);
  const modules = 'M1, M2, M3, M4, M5, M6, M7 e M8';

  const normalizeModuleCode = (value) => {
    if (value === undefined || value === null) return '';
    const text = String(value).trim().toUpperCase();
    if (!text) return '';
    if (text.startsWith('M')) return text;
    const numericPart = text.replace(/\D/g, '');
    return numericPart ? `M${numericPart}` : '';
  };

  const modulePerformanceByCode = useMemo(() => {
    return (modulePerfomance ?? []).reduce((acc, item) => {
      const moduleCode = normalizeModuleCode(item?.module);
      if (!moduleCode) return acc;

      acc[moduleCode] = item;
      return acc;
    }, {});
  }, [modulePerfomance]);

  const getStudentPerformanceByModule = (moduleCode) => {
    const perf = modulePerformanceByCode[moduleCode];
    if (!perf || !Number.isFinite(Number(perf?.total))) return 0;

    return Number((Number(perf.total) * 100).toFixed(1));
  };

  const formatPercent = (value) => `${value.toFixed(1).replace('.', ',')}%`;

  const cfpOfficialSummary = useMemo(() => {
    return CFP_MODULES.map((moduleItem) => {
      const moduleCode = `M${moduleItem.module}`;

      return {
        moduleCode,
        moduleLabel: `Módulo ${getRomanModule(moduleItem.module)} – ${moduleItem.name}`,
        officialPercent: formatPercent(moduleItem.weight),
        studentPercent: formatPercent(getStudentPerformanceByModule(moduleCode))
      };
    });
    //eslint-disable-next-line
  }, [modulePerformanceByCode]);

  const textoInicial = textData?.split("##imagem_relatório##")[0] || ""
  const dataGrafico = textData?.split("##imagem_relatório##")[1]?.split("##data_imagem:")[1]?.split("##")[0] || ""
  const textoFinal = textData?.split("##")[textData?.split("##")?.length-1] || ""


  const reportProvaResult =
    report !== undefined
      && reportExists
      && !isNaN(Math.round(reportDone[0]?.prova)) ? Math.round(report?.test?.done[0]?.prova) : 0;

if(modulePerfomance) {
  const allModules = Array.from({ length: MODULE_COUNT.cfp }, (_, i) => `M${i + 1}`);
  allModules.forEach(moduleName => {
    if(!modulePerfomance) return;
    if(!modulePerfomance.find(module => moduleName === module?.module)) {
      improve.push({module: moduleName, total: 0, tipo_prova: 'AULA'});
    }
});

  improve.sort((a, b) => {
    const moduleA = Number(String(a?.module ?? '').replace(/\D/g, ''));
    const moduleB = Number(String(b?.module ?? '').replace(/\D/g, ''));

    if (!Number.isFinite(moduleA) && !Number.isFinite(moduleB)) {
      return String(a?.module ?? '').localeCompare(String(b?.module ?? ''));
    }
    if (!Number.isFinite(moduleA)) return 1;
    if (!Number.isFinite(moduleB)) return -1;

    return moduleA - moduleB;
  });
}

  const improveMessage = (improve = []) => {
    if (isEmpty(improve)) return '';
    const total = (improve ?? []).length - 1;
    return improve.map((item, i) => {
      return (i > 0 && i < total ? ', ' : (i === total ? ' e ' : '')) + (item.tipo_prova === 'AULA' ? item.module : '');
    });
  };

  const recomendedPerformance = (modulePerfomance = false) => {
    if (!modulePerfomance) return false;

    const recommendedByModule = RECOMMENDED_CFP.reduce((acc, item) => {
      acc[item.module] = item.value;
      return acc;
    }, {});

    return modulePerfomance
      .map((module) => {
        const moduleCode = normalizeModuleCode(module?.module);
        const recommendedValue = recommendedByModule[moduleCode];

        if (!recommendedValue && recommendedValue !== 0) return null;
        return (module?.total * 100) < recommendedValue ? moduleCode : null;
      })
      .filter(item => item !== null);
  }

  // Função para truncar texto longo com reticências
  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }

  return (
    <>
      <Header>
        <Img src={Logo} alt="logo" />
      </Header>

      <Container style={{ display: 'block' }}>
        <NameRow justify="space-between">
          <Col>
            <h1>Olá {report?.name} :)</h1>
            <p>Este é o seu desempenho na primeira etapa do CFP®60 dias.</p>
          </Col>
          <Col>
            <ImgLogo src={LogoIcon} alt="logo" />
          </Col>
        </NameRow>

        <TextHeader>
          <div dangerouslySetInnerHTML={{ __html: textoInicial }} />
        </TextHeader>
        <Content>
          {
            typeof reportProvaResult === 'number' && (
              <TextHeader style={{ width: '100%', textAlign: 'center' }}>Você completou os exercícios de <strong>
                {reportProvaResult} provas</strong> das <strong> {TOTAL_REPORTS} disponíveis.</strong>
              </TextHeader>
            )
          }

          {
            typeof reportProvaResult === 'number' && (
              <BarchartH
                zIndex={1}
                displaySubtitle={'none'}
                displayAvaliable={"flex"}
                classNumber={reportProvaResult}
                percent={Number(((reportProvaResult / TOTAL_REPORTS) * 100).toFixed(1))}
                percentText={`${reportProvaResult}`}
                colorbk1={'#000A66'}
                total={TOTAL_REPORTS}
                textAvaliableDate={`* ${dataGrafico.replace("<p>", "").replace("</p>", "")}`}
              />
            )
          }
        </Content>

        <Description style={{ marginBottom: '2.816vw' }}>
          <div dangerouslySetInnerHTML={{ __html: textoFinal }} />
        </Description>

        <ReportText type='graph'>Desempenho geral</ReportText>

        <div style={{ marginBottom: '3vw', width: '100%' }}>
          <Score />
        </div>

        <ReportText type='description'>
          <p>Prova CFP® é composta por 140 questões divididas em 8 módulos.
            <br /> Você precisa atingir 70% no desempenho geral (98 acertos) e não pode acertar menos que 50% em nenhum dos módulos. Nosso calendário converge para que você veja a prova como um todo e, desta forma, sua chance de aprovação aumenta.</p>
          <p>Este gráfico representa seu Score Toro com os acertos de todos os exercícios que você resolveu na aulas na plataforma, desde aquela primeira prova de 20 perguntas até a última revisão.</p>
        </ReportText>

        {/* {
          ((totalScore ?? 0) >= 80 &&
            <ReportText type='description'>
              <p><span> No momento, você está acima de 80% no SCORE TORO, o que é um indicador muito favorável, tendo em vista isso, sugerimos manter o foco e continuar seguindo o cronograma de estudos.</span></p>
            </ReportText>
          )
        }
        {
          ((totalScore ?? 0) >= 70 && (totalScore ?? 0) <= 79 &&
            <ReportText type='description'>
              <p><span>No momento, você está acima de 70% no SCORE TORO, o que é um indicador favorável, tendo em vista isso, sugerimos manter o foco e continuar seguindo o cronograma de estudos e adicionar 25 questões extras diariamente.</span></p>
            </ReportText>
          )
        }
        {
          ((totalScore ?? 0) >= 50 && (totalScore ?? 0) <= 69 &&
            <ReportText type='description'>
              <p><span>No momento, você está quase chegando em 70% no SCORE TORO, o que é um indicador favorável, tendo em vista isso, sugerimos manter o foco e continuar seguindo o cronograma de estudos e adicionar 50 questões extras diariamente.</span></p>
            </ReportText>
          )
        }
        {
          (((totalScore ?? 0) <= 49 || totalScore.length === 3)  &&
            <ReportText type='description'>
              <p><span>No momento, você está abaixo de 50% de acertos na SCORE TORO, o que é um indicador não muito favorável, tendo em vista isso, sugerimos a migração para o <strong className='strong-span'>CFP® 30 DIAS</strong>, onde você poderá rever as aulas e assimilar melhor o conteúdo.</span></p>
            </ReportText>
          )
        } */}

        <ReportText type="graph">Desempenho por módulo</ReportText>
        <BartChartV
          linePercent={30}
          linePercentTwo={70}
          displaySubtitle={'flex'}
          subtitleMin={"seu desempenho"}
          subtitleRecommended={"recomendado"}
          positionSubtitle={'end'}
          includeRevision={true}
        />

        {false && (
          <div style={{ width: '100%', marginTop: '2vw', marginBottom: '2vw' }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '3fr 1fr 1fr',
              gap: '1vw',
              paddingBottom: '0.8vw',
              borderBottom: '1px solid #D6D6D6',
              fontFamily: 'Work Sans, sans-serif',
              fontSize: '1.15vw',
              fontWeight: 700,
              color: '#000533'
            }}>
              <span>Módulo oficial</span>
              <span>% oficial</span>
              <span>% acertos</span>
            </div>

            {cfpOfficialSummary.map((moduleItem) => (
              <div
                key={moduleItem.moduleCode}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '3fr 1fr 1fr',
                  gap: '1vw',
                  padding: '0.7vw 0',
                  borderBottom: '1px solid #EFEFEF',
                  fontFamily: 'Work Sans, sans-serif',
                  fontSize: '1.05vw',
                  color: '#434343'
                }}
              >
                <span>{moduleItem.moduleLabel}</span>
                <span>{moduleItem.officialPercent}</span>
                <span>{moduleItem.studentPercent}</span>
              </div>
            ))}
          </div>
        )}

        <ReportText type='description' style={{ marginTop: '3vw' }}>
          <p>Desta maneira, considerando os pontos que relatamos acima, orientamos que

            {/* ANCHOR */}
            {
              recomendedPerformance(modulePerfomance).length > 0  || totalAverage.length === 3
              ?
                <span className='strong-span'> você dê atenção ao(s) módulo(s) {totalAverage.length === 3 ? modules : improveMessage(improve)},
                que é(são) o(s) que está(ão) abaixo do recomendado pela Academia
                </span>
              :
              <span className='strong-span'> siga o cronograma normalmente, pois você está acima da média esperada em todos os módulos</span>
            }

            . Eles possuem alta relevância na sua prova. Você fará isso utilizando nossas aulas resumos, aumentando a carga de exercícios diários e quando possível a repetição deles. Além disso, ouvir os áudios destes módulos é fundamental.</p>
          <p>O Exame do CFP® divide-se em 8 módulos que totalizam 140 questões. Em seguida, vamos te contar um pouco sobre cada um deles e a importância para sua aprovação.</p>
        </ReportText>

        <TitleModule>Módulo I – Planejamento Financeiro</TitleModule>
        <ReportText type='description'>
          <p>Módulo que aborda os princípios, processos e habilidades do planejamento financeiro. Sua prova terá 18 (dezoito) questões, representando 12,9% do total.</p>
          <p><strong>Recomendação: 80% (representa 14 acertos de 18 questões nas bíblias/simulado)</strong></p>
        </ReportText>

        <div style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}>
          <TitleModule>Módulo II – Gestão Financeira</TitleModule>
          <ReportText type='description'>
            <p>Módulo que aborda conceitos de gestão financeira pessoal e empresarial. Sua prova terá 20 (vinte) questões, representando 14,3% do total.</p>
            <p><strong>Recomendação: 75% (representa 15 acertos de 20 questões nas bíblias/simulado)</strong></p>
          </ReportText>
        </div>

        <ReportBreakPage />

        <TitleModule>Módulo III – Investimentos e Gestão de Ativos</TitleModule>
        <ReportText type='description'>
          <p>É o módulo com a maior quantidade de questões, abordando investimentos e gestão de ativos. Sua prova terá 24 (vinte e quatro) questões, representando 17,1% do total.</p>
          <p><strong>Recomendação: 80% (representa 19 acertos de 24 questões nas bíblias/simulado)</strong></p>
        </ReportText>

        <TitleModule>Módulo IV – Aposentadoria</TitleModule>
        <ReportText type='description'>
          <p>Módulo que aborda planejamento de aposentadoria, incluindo <strong>PGBL</strong>, <strong>VGBL</strong>, tributação progressiva e regressiva, e cálculos com fatores atuariais. Sua prova terá 17 (dezessete) questões, representando 12,1% do total.</p>
          <p><strong>Recomendação: 80% (representa 14 acertos de 17 questões nas bíblias/simulado)</strong></p>
        </ReportText>

        <TitleModule>Módulo V – Seguros e Gestão de Riscos</TitleModule>
        <ReportText type='description'>
          <p>Módulo que aborda a aplicabilidade de seguros e conceitos técnicos de cada produto de gestão de riscos. Sua prova terá 17 (dezessete) questões, representando 12,1% do total.</p>
          <p><strong>Recomendação: 80% (representa 14 acertos de 17 questões nas bíblias/simulado)</strong></p>
        </ReportText>

        <TitleModule>Módulo VI – Planejamento Tributário</TitleModule>
        <ReportText type='description'>
          <p>Módulo que aborda tributação de produtos, <strong>cálculo de Imposto de Renda Pessoa Física</strong> e <strong>tributação de investimentos</strong>. Sua prova terá 17 (dezessete) questões, representando 12,1% do total.</p>
          <p><strong>Recomendação: 75% (representa 13 acertos de 17 questões nas bíblias/simulado)</strong></p>
        </ReportText>

        <TitleModule>Módulo VII – Planejamento Patrimonial e Sucessório</TitleModule>
        <ReportText type='description'>
          <p>Módulo que aborda a <strong>distribuição da herança</strong>, conceito de <strong>herdeiros necessários</strong> e as doações com <strong>cláusulas restritivas</strong>. Sua prova terá 17 (dezessete) questões, representando 12,1% do total.</p>
          <p><strong>Recomendação: 75% (representa 13 acertos de 17 questões nas bíblias/simulado)</strong></p>
        </ReportText>

        <TitleModule>Módulo VIII – Psicologia do Planejamento Financeiro</TitleModule>
        <ReportText type='description'>
          <p>Módulo que aborda os aspectos psicológicos e comportamentais do planejamento financeiro. Sua prova terá 10 (dez) questões, representando 7,1% do total.</p>
          <p><strong>Recomendação: 80% (representa 8 acertos de 10 questões nas bíblias/simulado)</strong></p>
        </ReportText>

        <ReportBreakPage />

        <div style={{ breakInside: 'avoid', pageBreakInside: 'avoid' }}>
          <ReportText type="graph">Desempenho por aula</ReportText>
          <ReportText type='description'>
            <p>Foque nas aulas em <strong style={{ color: '#fcaf20', textDecoration: 'underline' }}>laranja</strong> para elevar ainda mais sua média em cada módulo.</p>
          </ReportText>

          <div style={{ marginBottom: '2vw' }}>
            <LegendChart
              displaySubtitle={'flex'}
              subtitleMin={'Abaixo do Esperado'}
              subtitleRecommended={'Acima do Esperado'}
              colorOne={'#F9DDC0'}
              colorTwo={'#C1C6F2'}
            />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
          {
            reportPerClass?.map((item) => {
              return (
                <BarchartH
                  key={`report-class-${item.titulo}-${item.cor}-${item.porcentagem}`}
                  zIndex={0}
                  displaySubtitle={'none'}
                  displayAvaliable={"none"}
                  classNumber={5}
                  percentText={`${Math.round(item.porcentagem)}%`}
                  percent={Math.round(item.porcentagem)}
                  total={truncateText(item.titulo, 45)}
                  fontSize={'1.2vw'}
                  positionPercent={'start'}
                  colorbk1={item.cor}
                  colorText={'#000000'}
                  description={"flex"}
                  textdescription={item.texto}
                  height={"2.258vw"}
                  widthGraph={"45%"}
                />
              )
            })
          }
        </div>

        <div style={{ marginTop: '3vw' }}>

          <ReportText type="description" dangerouslySetInnerHTML={{ __html: suggestion?.replace('{name}', report?.name) }} />

          <FooterReport>
            <div className='logo-gold'>
              <img src={LogoGold} alt='logo' />
            </div>
            <div className='description-footer'>
              <p>Muito obrigado por escolher a Rafael Toro Academia de Finanças :)</p>
              <p>Um grande abraço dos professores e amigos Rafael Toro, Victório Santi e equipe ART.</p>
            </div>
          </FooterReport>
        </div>
      </Container>
    </>
  );
};
export default CfpReport;
